import { Skeleton } from "@mui/material";
import { BlockCard, MetricTileSkeleton } from "../primitives";
import styles from "./style.module.scss";

interface AccountInfoBlockSkeletonProps {
  count?: number;
  className?: string;
}

/** Same card, same six-up grid, same tile anatomy as the loaded block. */
function AccountInfoBlockSkeleton({
  count = 6,
  className,
}: AccountInfoBlockSkeletonProps) {
  return (
    <BlockCard
      title={<Skeleton variant="text" width={150} height={20} />}
      compactTitle
      className={className}
    >
      <div className={styles.grid}>
        {Array.from({ length: count }).map((_, index) => (
          <MetricTileSkeleton key={index} />
        ))}
      </div>
    </BlockCard>
  );
}

export default AccountInfoBlockSkeleton;
